module.exports = __webpack_public_path__ + "img/vue2-languette_blanc.63b2a39e.png";